import { $ as n } from "./Promise.bs-06a7bae6.mjs";

import { e as t } from "./caml_obj-c29533cc.mjs";

import { r, c as e } from "./belt_Array-b9ebcaa6.mjs";

import { g as o, a as i, b as u, i as f, f as a, c as l, d as c, m as s } from "./belt_Option-91f3b350.mjs";

import { s as m, n as p, v as d } from "./caml_option-16487d6d.mjs";

function placeholder(n) {}

function makeSome(n) {
  return m(n);
}

function makeNone(n) {}

function fromNullable(n) {
  if (null == n) {
    return;
  } else {
    return m(n);
  }
}

function fromFalsy(n) {
  if (n) {
    return n;
  }
}

function _fromPredicate(n, t) {
  return a(null == n ? void 0 : m(n), (function(n) {
    if (t(n)) {
      return m(n);
    }
  }));
}

function fromPredicate() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _fromPredicate(t, n[0]);
    };
  }
  return _fromPredicate(arguments[0], arguments[1]);
}

function fromExecution(n) {
  try {
    return m(n(void 0));
  } catch (n) {
    return;
  }
}

function fromPromise(t) {
  return n(t.then((function(n) {
    return m(n);
  })), (function(n) {
    return Promise.resolve(void 0);
  }));
}

var h = l;

function map() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return h(t, n[0]);
    };
  }
  return h(arguments[0], arguments[1]);
}

var _ = c;

function flatMap() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _(t, n[0]);
    };
  }
  return _(arguments[0], arguments[1]);
}

var v = s;

function mapWithDefault() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return v(t, n[0], n[1]);
    };
  }
  return v(arguments[0], arguments[1], arguments[2]);
}

function _mapNullable(n, t) {
  if (void 0 !== n) {
    return p(t(d(n)));
  }
}

function mapNullable() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _mapNullable(t, n[0]);
    };
  }
  return _mapNullable(arguments[0], arguments[1]);
}

function _filter(n, t) {
  return c(n, (function(n) {
    if (t(n)) {
      return m(n);
    }
  }));
}

function filter() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _filter(t, n[0]);
    };
  }
  return _filter(arguments[0], arguments[1]);
}

var g = i;

function getWithDefault() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return g(t, n[0]);
    };
  }
  return g(arguments[0], arguments[1]);
}

var N = o;

function toNullable(n) {
  return i(n, null);
}

function toUndefined(n) {
  return i(n, void 0);
}

function _toResult(n, t) {
  if (void 0 !== n) {
    return {
      TAG: 0,
      _0: d(n)
    };
  } else {
    return {
      TAG: 1,
      _0: t
    };
  }
}

function toResult() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _toResult(t, n[0]);
    };
  }
  return _toResult(arguments[0], arguments[1]);
}

function _match(n, t, r) {
  if (void 0 !== n) {
    return t(d(n));
  } else {
    return r(void 0);
  }
}

function match() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _match(t, n[0], n[1]);
    };
  }
  return _match(arguments[0], arguments[1], arguments[2]);
}

var b = u;

var z = f;

function _tap(n, t) {
  if (void 0 !== n) {
    t(d(n));
    return n;
  } else {
    return n;
  }
}

function tap() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _tap(t, n[0]);
    };
  }
  return _tap(arguments[0], arguments[1]);
}

function _contains(n, r) {
  return s(n, !1, (function(n) {
    return t(n, r);
  }));
}

function contains() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _contains(t, n[0]);
    };
  }
  return _contains(arguments[0], arguments[1]);
}

function _zip(n, t) {
  if (void 0 !== n && void 0 !== t) {
    return [ d(n), d(t) ];
  }
}

function zip() {
  if (1 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _zip(t, n[0]);
    };
  }
  return _zip(arguments[0], arguments[1]);
}

function _zipWith(n, t, r) {
  if (void 0 !== n && void 0 !== t) {
    return m(r(d(n), d(t)));
  }
}

function zipWith() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _zipWith(t, n[0], n[1]);
    };
  }
  return _zipWith(arguments[0], arguments[1], arguments[2]);
}

function _fold(n, t, r) {
  if (void 0 !== n) {
    return t(d(n));
  } else {
    return r(void 0);
  }
}

function fold() {
  if (2 === arguments.length) {
    const n = arguments;
    return function fn(t) {
      return _fold(t, n[0], n[1]);
    };
  }
  return _fold(arguments[0], arguments[1], arguments[2]);
}

function all(n) {
  return r(n, [], (function(n, t) {
    return c(n, (function(n) {
      if (void 0 !== t) {
        return e(n, [ d(t) ]);
      }
    }));
  }));
}

const Some = n => n;

const W = void 0;

var P = {
  __proto__: null,
  Some,
  None: undefined,
  placeholder,
  makeSome,
  makeNone,
  fromNullable,
  fromFalsy,
  fromPredicate,
  fromExecution,
  fromPromise,
  map,
  flatMap,
  mapWithDefault,
  mapNullable,
  filter,
  getWithDefault,
  getExn: N,
  toNullable,
  toUndefined,
  toResult,
  match,
  isNone: b,
  isSome: z,
  tap,
  contains,
  zip,
  zipWith,
  fold,
  all
};

export { fold as A, all as B, W as N, Some as S, makeNone as a, fromFalsy as b, fromPredicate as c, fromExecution as d, fromPromise as e, fromNullable as f, map as g, flatMap as h, P as i, mapWithDefault as j, mapNullable as k, filter as l, makeSome as m, getWithDefault as n, N as o, placeholder as p, toUndefined as q, toResult as r, match as s, toNullable as t, b as u, z as v, tap as w, contains as x, zipWith as y, zip as z };
